import TIcon from './icon.vue'
export default TIcon



// WEBPACK FOOTER //
// ./src/components/icon/index.js